export default __webpack_public_path__ + "static/media/backtick.4af8a4f1.svg";